import { debounce } from 'lodash';

import { buildSelectableSchool } from '@/utils/buildSelectable';

import { search } from '@/api/SchoolApi';

import { Selectable } from '@/components/selectBox/selectBox';

export function useSchoolsSearch(searchFilters?: Record<string, unknown>) {
  const searchQuery = ref('');
  const isLoading = ref(false);
  const schoolOptions = ref<Selectable<number>[]>([]);
  const localSearchFilters = ref(searchFilters);

  const searchSchools = debounce(async (query: string) => {
    const response = await search({
      filters: {
        ...localSearchFilters.value,
        search: query
      }
    });
    schoolOptions.value = response.map((school) =>
      buildSelectableSchool(school)
    ) as Selectable<number>[];

    isLoading.value = false;
  }, 300);

  function updateSearchFilters(searchFilters?: Record<string, unknown>) {
    localSearchFilters.value = searchFilters;
    searchSchools(searchQuery.value);
  }

  function onQueryChange(query: string): void {
    isLoading.value = true;
    searchQuery.value = query;

    searchSchools(query);
  }

  return {
    schoolOptions,
    isLoading,
    onQueryChange,
    updateSearchFilters
  };
}
